import { render, staticRenderFns } from "./IscrizioniAttivitaAllievo.vue?vue&type=template&id=05ab85aa&scoped=true&"
import script from "./IscrizioniAttivitaAllievo.vue?vue&type=script&lang=ts&"
export * from "./IscrizioniAttivitaAllievo.vue?vue&type=script&lang=ts&"
import style0 from "./IscrizioniAttivitaAllievo.vue?vue&type=style&index=0&id=05ab85aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ab85aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VRow})
